import { Box, styled } from "@mui/material";
import closeIcon from 'assets/icon-close.png';

export const CloseIconBox = styled(Box)(() => ({
  backgroundImage: `url(${closeIcon})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  width: 25,
  height: 25
}))